import { Scoreable } from './promptTesting'

export type ImageTestCase = {
    id: string
    name: string
    mimeType: string
    blob: Blob
    target: 'Yes' | 'No'
}

export type ImagePromptResult = Scoreable & {
    fileName: string
    target: 'Yes' | 'No'
    score: number | null
    justification: string
}

/** Convert a Blob to a base64 string (without the data URL prefix) */
export async function blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
            const result = reader.result as string
            // Strip "data:<mime>;base64," prefix
            const base64 = result.split(',')[1]
            resolve(base64)
        }
        reader.onerror = reject
        reader.readAsDataURL(blob)
    })
}

/** Estimate total payload size in bytes from image blobs */
export function estimatePayloadSize(blobs: Blob[]): number {
    return blobs.reduce((sum, blob) => sum + blob.size, 0)
}

const MAX_TOTAL_PAYLOAD = 5 * 1024 * 1024 // 5MB

export function validateTotalPayloadSize(blobs: Blob[]): { valid: boolean; message?: string } {
    const total = estimatePayloadSize(blobs)
    if (total > MAX_TOTAL_PAYLOAD) {
        return {
            valid: false,
            message: `Total image size (${(total / 1024 / 1024).toFixed(1)}MB) exceeds 5MB limit. Remove some images to proceed.`,
        }
    }
    return { valid: true }
}
